module.exports = __webpack_public_path__ + "img/workbench_icon11.9ab0e03e.svg";